import { PageHeading } from '@src/components/PageHeading/PageHeading';
import { BoxPicture } from '@src/components/BoxPicture/BoxPicture';
import { GameBadge } from '@src/components/GameBadge/GameBadge';
import { testIdAttr, testIdFor } from '@src/components/testId';
import './BoxSelectHero.css';

export interface BoxSelectHeroProps {
  name: string;
  picture?: string | null;
  logo?: string | null;
  title: string;
  /** Optional intro under the title — omit when a Note carries the caution. */
  lead?: string;
  /** Omit the game picture — card-recover already names the participant below. */
  hideArt?: boolean;
  /** The main game sign already shows this identity. */
  hideIdentity?: boolean;
  testId?: string;
}

/** Hero for shared-link and recover screens — art left, name, title and lead right. */
export function BoxSelectHero({
  name,
  picture,
  logo,
  title,
  lead,
  hideArt = false,
  hideIdentity = false,
  testId,
}: BoxSelectHeroProps) {
  return (
    <header
      className={`box-select-hero${hideArt ? ' box-select-hero--no-art' : ''}`}
      {...testIdAttr(testId)}
    >
      {hideArt || hideIdentity ? null : (
        <div className="box-select-hero__art-slot">
          <div className="box-select-hero__art" {...testIdAttr(testIdFor(testId, 'art'))}>
            <BoxPicture picture={picture} logo={logo} />
          </div>
        </div>
      )}
      <div className="box-select-hero__copy">
        {!hideIdentity && <GameBadge name={name} testId={testIdFor(testId, 'name')} />}
        <PageHeading title={title} subtitle={lead} testId={testIdFor(testId, 'title')} subtitleTestId={testIdFor(testId, 'lead')} />
      </div>
    </header>
  );
}
